import AjaxDataService from 'services/ajax.service';

export default {
  // TODO: This should be pulled out into it's own third party specific file
  data() {
    return {
      initialThirdParty: ''
    };
  },
  methods: {
    getDefaultFormData() {
      const dataItem = {};
      Object.values(this.columnConstants).forEach(fieldInfo => {
        dataItem[fieldInfo.field] = '';
        if (fieldInfo.fieldType === 'numeric') {
          dataItem[fieldInfo.field] = 0;
        }
        if (fieldInfo.fieldType === 'boolean') {
          dataItem[fieldInfo.field] = false;
        }
        if (fieldInfo.default !== undefined) {
          dataItem[fieldInfo.field] = fieldInfo.default;
        }
      });
      dataItem.isActive = true;
      return dataItem;
    },
    clearBlankLookupIDs(formData) {
      Object.values(this.columnConstants).forEach(fieldInfo => {
        if (fieldInfo.isLookupID && formData[fieldInfo.field] === 0) {
          // eslint-disable-next-line
          delete formData[fieldInfo.field];
        }
      });
    },
    addClick() {
      const eventData = this.getDefaultFormData(this.columnConstants);
      eventData.editMode = false;

      this.$refs.addEditRef.openDialog(eventData);
    },
    editClick(e) {
      const eventData = this.getDefaultFormData(this.columnConstants);
      const formData = { ...eventData, ...e };
      formData.editMode = true;
      // TODO: This should be pulled out into it's own third party specific file
      this.initialThirdParty = formData.thirdParty;
      this.$refs.addEditRef.openDialog(formData);
    },
    onFormSubmit(formData, isEdit, isDelete, resolve) {
      // eslint-disable-next-line
      delete formData.modifiedOn;
      this.clearBlankLookupIDs(formData);
      if (isEdit) {
        if (isDelete) {
          const params = { id: formData[this.idField] };
          AjaxDataService.getData(this.props.api.deletePrecheck, params)
            .then(response => response.data)
            .then(relatedItems => {
              if (relatedItems.count > 0) {
                resolve([
                  `This item cannot be deleted. There are ${JSON.stringify(relatedItems.description)} related items.`
                ]);
                // eslint-disable-next-line no-alert
              } else if (window.confirm('Are you sure you want to delete this item?')) {
                AjaxDataService.deleteData(this.props.api.data, params);
                window.location.reload();
                resolve([]);
              } else {
                resolve([]);
                // No errors but confirm canceled
              }
            });
        } else {
          // TODO: This should be pulled out into it's own third party specific file
          // eslint-disable-next-line
          formData.oldThirdParty = this.initialThirdParty;
          AjaxDataService.putData(this.props.api.data, formData).then(() => {
            this.$nextTick(() => {
              this.$refs.parentGrid.loadData(true);
            });
          });
          resolve([]);
        }
      } else {
        AjaxDataService.postData(this.props.api.data, formData);
        resolve([]);
      }
    }
  }
};
